import { render } from "./children.vue?vue&type=template&id=67a73b81&scoped=true"
import script from "./children.vue?vue&type=script&lang=js"
export * from "./children.vue?vue&type=script&lang=js"

import "./children.vue?vue&type=style&index=0&id=67a73b81&lang=scss&scoped=true"
import "./children.vue?vue&type=style&index=1&id=67a73b81&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a73b81"]])

export default __exports__